import React from 'react'
import PropTypes from 'prop-types';
import { __error } from 'Common/scripts/consoleHelper'
// import CategoryPage from 'Modules/Category/containers/index';
import { AlgoliaHits } from 'Modules/AlgoliaSearch/AlgoliaHits';



const SearchPage = props => {
  /* let filter = {};
  if (props.match.params.kw) {
    filter = Object.assign({ search: { keywords: props.match.params.kw } })
  }else{
    return <p>Nothing to search</p>
  }

  return <CategoryPage searchFilter={filter} /> */
  return <AlgoliaHits />
}

SearchPage.propTypes = {
  // toggleDrawer: PropTypes.func.isRequired
  // prop: PropTypes.type.isRequired
  // onEditRecord: PropTypes.func.isRequired
}

export default SearchPage;
